export const dataHooks = {
  provider: 'dnd-provider',
};
